import logo from './logo.svg';
import './App.css';
import {useEffect , useState , useRef} from "react"

import {BrowserRouter as Router , Routes , Route , Link } from 'react-router-dom';

import socket from './socket.js'




//import Home from "./pages/Home";
//import About from "./pages/About";
import MainRoute from "./pages/MainRoute";

socket.connect ();

socket.on ('connect',()=>{
  console.log('coooooooooooooooooonect');
})
socket.on ('connect_error',(data)=>{
  console.log('connect_error',data);
})
socket.on ('disconnect',(data)=>{
  console.log('disconnect',data);
})



function App() {

  return (
  <Router>
    <Routes>
      <Route path="*" element={<MainRoute/>} />
    </Routes>
  </Router>
  );
}



/*    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
      <p>

      </p>
    </div>
    */




export default App;
